import React from 'react';
import MyBread from '../../components/Breadcrumbs';
import FactoryInfo from '../../components/FactoryInfo';
import CompanyInfo from '../../components/CompanyInfo';

export default function Account() {
  return (
    <>
      <div>
        <MyBread />
        <div>
          <FactoryInfo/>
          <CompanyInfo />
        </div>
      </div>
    </>
  )
}
